/** Saving what the page shows: a table as CSV, or any blob as a file. */

export type Cell = string | number

export function fileSlug(title: string, fallback = 'data'): string {
  return (
    title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || fallback
  )
}

export function toCsv(headers: string[], rows: Cell[][]): string {
  const escape = (value: Cell) => {
    let text = String(value)
    // Report text is untrusted: a cell starting with these would run as a
    // formula when the file is opened in a spreadsheet.
    if (typeof value === 'string' && /^[=+\-@\t\r]/.test(text)) text = `'${text}`
    return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text
  }
  return [headers, ...rows].map((row) => row.map(escape).join(',')).join('\r\n')
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  // Released on the next turn: released at once, some browsers cancel the
  // download before it starts.
  setTimeout(() => URL.revokeObjectURL(url), 0)
}

export function downloadCsv(title: string, headers: string[], rows: Cell[][]): void {
  const blob = new Blob([toCsv(headers, rows)], { type: 'text/csv;charset=utf-8;' })
  downloadBlob(blob, `${fileSlug(title)}-data.csv`)
}
